import React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Grid from "@mui/material/Grid";
import Iframe from "./Iframe";

const useStyles = makeStyles((theme) => ({
  root: {
    // maxWidth: 400,
    flexGrow: 1,
    marginTop: theme.spacing(2),
  },
  img: {
    // height: 255,
    // maxWidth: 400,
    overflow: "hidden",
    display: "block",
    width: "100%",
  },
  stepper: {
    backgroundColor: "inherit",
  },
  IframeContainer: {
    overflow: "hidden",
    paddingBottom: "56.25%",
    position: "relative",
    height: "0",
  },
}));

export default function Slider(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = props.videos.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Grid container direction={"row"} alignItems={"center"} justifyContent={"center"}>
      <Grid item xs={12}>
        <div className={classes.root}>
          <div className={classes.IframeContainer}>
            <Iframe src={props?.videos[activeStep]?.video} autoplay={false} />
          </div>
          <MobileStepper
            steps={maxSteps}
            position="static"
            variant="dots"
            activeStep={activeStep}
            className={classes.stepper}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
              </Button>
            }
          />
        </div>
      </Grid>
    </Grid>
  );
}
